export enum UserFixedNotificationsFlow {
    developerAccount = 'developerAccount',
    emailReminder = 'emailReminder',
    downgraded = 'downgraded',
    accountDisabled = 'accountDisabled',
    notActivated = 'notActivated',
    paymentFailure = 'paymentFailure',
    pendingConfirmation = 'pendingConfirmation',
    cancellationPending = 'cancellationPending',
}
